export default __webpack_public_path__ + "static/media/Instagram.0527dfec.svg";